import { PageTemplate } from '@/components/molecules/PageTemplate';

export const AIAssistant: React.FC = () => {
  return (
    <PageTemplate
      title="AI Assistant"
      description="Get intelligent help with your Salesforce development"
    />
  );
};

export default AIAssistant;